import { render, staticRenderFns } from "./basicList.vue?vue&type=template&id=7417c2f3&scoped=true"
import script from "./basicList.vue?vue&type=script&lang=ts"
export * from "./basicList.vue?vue&type=script&lang=ts"
import style0 from "./basicList.vue?vue&type=style&index=0&id=7417c2f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7417c2f3",
  null
  
)

export default component.exports